import { motion } from 'framer-motion';
import { ArrowUpRight, Instagram, Linkedin, Twitter, Youtube } from 'lucide-react';

const footerLinks = [
  {
    title: 'Services',
    links: [
      { name: 'Video Production', href: '#services' },
      { name: 'Social Media', href: '#services' },
      { name: 'Brand Identity', href: '#services' },
      { name: 'Web Development', href: '#services' },
    ],
  },
  {
    title: 'Company',
    links: [
      { name: 'About Us', href: '#about' },
      { name: 'Equipo', href: '#team' },
      { name: 'Pricing', href: '#pricing' },
      { name: 'Contact', href: '#contact' },
    ],
  },
];

const socialLinks = [
  { icon: Instagram, href: '#', label: 'Instagram' },
  { icon: Linkedin, href: '#', label: 'LinkedIn' },
  { icon: Twitter, href: '#', label: 'Twitter' },
  { icon: Youtube, href: '#', label: 'YouTube' },
];

export default function Footer() {
  const scrollToSection = (href) => {
    if (href.startsWith('#')) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="relative bg-black border-t border-white/5" data-testid="footer">
      {/* CTA Section */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-8">
            <span className="text-white">Trabajemos</span>
            <br />
            <span className="gold-text">Juntos</span>
          </h2>
          <motion.button
            onClick={() => scrollToSection('#contact')}
            className="group inline-flex items-center gap-3 border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black px-12 py-6 text-sm font-bold tracking-[0.15em] uppercase transition-all duration-300"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            data-testid="footer-start-project-btn"
          >
            Iniciar Proyecto
            <ArrowUpRight
              size={20}
              className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
            />
          </motion.button>
        </motion.div>
      </div>

      {/* Links Section */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
          <div className="grid md:grid-cols-4 gap-12 md:gap-8">
            {/* Brand */}
            <div className="md:col-span-2">
              <div className="flex items-baseline gap-1 mb-6">
                <span className="text-2xl font-bold tracking-[0.2em] text-white font-['Manrope']">
                  ORIAN PARTNERS
                </span>
                <span className="text-sm font-light tracking-[0.15em] text-[#D4AF37] font-['Inter']">
                  STUDIO
                </span>
              </div>
              <p className="text-sm text-zinc-500 leading-relaxed max-w-sm mb-8">
                Estudio de marketing estratégico enfocado en construir marcas, sistemas digitales
                y estrategias de crecimiento que entregan resultados medibles.
              </p>
              {/* Social Links */}
              <div className="flex gap-4">
                {socialLinks.map((social) => (
                  <motion.a
                    key={social.label}
                    href={social.href}
                    className="w-10 h-10 border border-white/10 flex items-center justify-center text-zinc-500 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"
                    whileHover={{ y: -3 }}
                    aria-label={social.label}
                    data-testid={`social-${social.label.toLowerCase()}`}
                  >
                    <social.icon size={18} />
                  </motion.a>
                ))}
              </div>
            </div>

            {/* Links */}
            {footerLinks.map((column) => (
              <div key={column.title}>
                <h3 className="text-xs font-bold tracking-[0.2em] uppercase text-white mb-6">
                  {column.title}
                </h3>
                <ul className="space-y-4">
                  {column.links.map((link) => (
                    <li key={link.name}>
                      <button
                        onClick={() => scrollToSection(link.href)}
                        className="text-sm text-zinc-500 hover:text-[#D4AF37] transition-colors"
                      >
                        {link.name}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-600">
            © {new Date().getFullYear()} Orian Partners. All rights reserved.
          </p>
          <div className="flex gap-6">
            <button className="text-xs text-zinc-600 hover:text-zinc-400 transition-colors">
              Privacy Policy
            </button>
            <button className="text-xs text-zinc-600 hover:text-zinc-400 transition-colors">
              Terms of Service
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
